import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { autoCompleteDelay } from "../../config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FetchAutoCompleteData, FindTranslatedKey, arraysAreEqual, convertToNumber, handleDateChange } from "../CommonComponents/CustomHooks";
import { AutoCompleteBox, DateBox, FormButton, InputBox, base64ToBlob } from "../CommonComponents/InputBox";
import { OperationalTable } from "../CommonComponents/OperationalTable";

const DispatchEntry = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [scanNo, setScanNo] = useState('')
    const [CheckAll, setCheckAll] = useState(false)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const inputrefs = useRef([]);
    const selectedDate2 = new Date();
    const dateArr2 = selectedDate2.toDateString().split(" ");
    const formattedDate1 = `${dateArr2[2]}-${dateArr2[1]}-${dateArr2[3]}`;
    const [invoicePrint, setInvoicePrint] = useState(false)
    const [dispatchPrint, setdispatchPrint] = useState('')
    const [formData, setFormData] = useState({
        "dispatchNo": '',
        "dispatchDate": formattedDate1,
        "airlineName": '',
        "mawb": '',
        "pod": '',
        "pol": '',
        "flightNo": '',
        "etaDate":'',
        "toBCode": '',
        "manifestNo": '',
        "totalPCS": '',
        "totalWeight": '',
        "manifestNoList": []
    });

    const handleClear = () => {
        setFormData({
            "dispatchDate": formattedDate1,
            "airlineName": '',
            "mawb": '',
            "pod": '',
            "pol": '',
            "flightNo": '',
            "etaDate": '',
            "toBCode": '',
            "manifestNo": '',
            "totalPCS": '',
            "totalWeight": '',
            "manifestNoList": []
        });
        inputrefs.current['txtDispatchDate'].focus();
        GetDispathchDetail();
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Operation/DispatchEntry', { ...formData, manifestNo: (formData.manifestNoList).toString() })
        await dispatch(setSubLoading(false))
        if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED' || data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        }
        if (data.status === 'SUCCESS') {
            await setdispatchPrint(data.dispatchNo)
            await setInvoicePrint(true)
        }
    }


    const handlePrint = async (value) => {
        await dispatch(setSubLoading(true))
        let imgresult = await ApiCall('/api/Report/DispatchPrint', { DispatchNo: dispatchPrint });
        await dispatch(setSubLoading(false))
        let result = imgresult;
        if (result.status === 'ERROR' || result.status === 'EXPIRED') {
            await NotificationSound(result.status, result.message, result.focus, inputrefs, handleClear);
            await dispatch(setSubLoading(false))
        }
        const blob = base64ToBlob(result.documentPdfBase64?.split(',')[1], 'application/pdf');
        const url = URL.createObjectURL(blob);
        const PDFWindow = window.open("");
        PDFWindow.document.write("<iframe width='100%' height='100%' src='" + url + "'></iframe>");

    }



    const GetDispathchDetail = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            "PageIndex": PageIndex.toString(),
            ...sortConfig,
            "Type": "S",
        }
        setIsLoading(true)
        let data = await ApiCall('/api/Operation/GetDispatchDetail', GetData)
        setTableData(data)
        setIsLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleCheck = (id, manifestNo) => {
        const updatedAwbNoList = [...formData.manifestNoList];
        const index = updatedAwbNoList.indexOf(manifestNo);

        if (index !== -1) {
            updatedAwbNoList.splice(index, 1);
        } else {
            updatedAwbNoList.push(manifestNo);
        }
        setFormData({ ...formData, manifestNoList: updatedAwbNoList });
    };

    const handleCheckAll = (value) => {
        setCheckAll(value);
        const updatedTableData = tableData?.Data.map(item => {
            return {
                ...item,
                checkStatus: value
            };
        });
        setTableData(prevCNResult => ({
            ...prevCNResult,
            Data: updatedTableData
        }));
        const updatedAwbNoList = value ? tableData?.Data.map(item => item.ManifestNo) : [];
        let updatedPcs = value ? tableData?.Data.map(item => item.Pcs) : [];
        updatedPcs = updatedPcs?.reduce((total, currentValue) => total + Number(currentValue), 0);
        let updatedActWgt = value ? tableData?.Data.map(item => item.Weight) : [];
        updatedActWgt = updatedActWgt?.reduce((total, currentValue) => total + Number(currentValue), 0);
        setFormData({
            ...formData, manifestNoList: updatedAwbNoList,
            pcs: updatedPcs ? updatedPcs.toString() : '',
            weight: updatedActWgt ? updatedActWgt.toString() : ''
        });
    };

    const HandleScanData = async () => {
        if (!scanNo) {
            await NotificationSound('ERROR', 'Please enter Manifest No.!', 'txtManifestNo', inputrefs);
            return;
        } else {
            let isAvaialble = tableData?.Data?.filter(item => item.ManifestNo === scanNo).length;
            if (isAvaialble) {
                let tableData1 = tableData.Data.map(item => {
                    if (scanNo === item.ManifestNo && item.checkStatus === false) {
                        return {
                            ...item,
                            checkStatus: true
                        }
                    } else {
                        return {
                            ...item,
                            checkStatus: item.checkStatus ? item.checkStatus : false
                        }
                    }
                })
                setScanNo('')
                const updatedList = tableData1?.filter(item => item.checkStatus).map(item => item.ManifestNo) || [];
                setFormData({ ...formData, manifestNoList: [...updatedList] })
            } else {
                setScanNo('')
                await NotificationSound('ERROR', 'Manifest Not Found!', 'txtManifestNo', inputrefs);
                return;
            }
        }
    }

    useEffect(() => {
        let newTableData = tableData?.Data?.map(item => {
            const checkStatus = formData?.manifestNoList?.some(manifestNo => item.ManifestNo === manifestNo) ? true : false;
            return { ...item, checkStatus };
        });
        let newCheckedData = newTableData?.filter(item => item.checkStatus)
        let updatedPcs = newCheckedData?.map(item => item.Pcs)
        updatedPcs = updatedPcs?.reduce((total, currentValue) => total + Number(currentValue), 0);
        let updatedActWgt = newCheckedData?.map(item => item.Weight)
        updatedActWgt = updatedActWgt?.reduce((total, currentValue) => total + Number(currentValue), 0);
        setFormData({
            ...formData,
            pcs: updatedPcs ? updatedPcs.toString() : '',
            weight: updatedActWgt ? updatedActWgt.toString() : ''
        });

        if (!arraysAreEqual(newTableData, tableData.Data)) {
            setTableData(CNResult => ({
                ...tableData, Data: newTableData,
                HideColumns: CNResult?.HideColumns ? [...CNResult?.HideColumns, 'checkStatus'] : ['checkStatus']
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData.Data, formData.manifestNoList]);

    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
    };
    const handleChange1 = (event, value) => {
        GetDispathchDetail(value);
    };
    useEffect(() => {
        GetDispathchDetail()
    }, [sortConfig])

    useEffect(() => {
      
        document.title = 'Dispatch Entry';
        inputrefs.current['txtDispatchDate'].focus();
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <span className="fs-6 fw-bold headingspan"> {FindTranslatedKey('Dispatch Entry')}</span>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <InputBox
                            label=' Number'
                            PlaceHolderText='System Generated'
                            inputrefs={inputrefs}
                            id='txtDispatchNo'
                            value={formData.dispatchNo}
                            disabled={true}
                        />
                        <DateBox
                            inputrefs={inputrefs}
                            label="Dispatch Date"
                            placeholder="Dispatch Date"
                            id='txtDispatchDate'
                           // value={formData.dispatchDate ? formData.dispatchDate : ''}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtToBranch'].focus()
                                };
                            }}
                            required={true}
                            selected={formData.dispatchDate === '' ? '' : new Date(formData.dispatchDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'dispatchDate')}
                        />

                       
                        <AutoCompleteBox
                            label='To Branch'
                            placeholder='To Branch'
                            inputrefs={inputrefs}
                            id='txtToBranch'
                            value={formData.toBCode}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtAirlineName'].focus() };
                            }}
                            inputValue={formData.toBCode ? formData.toBCode : ''}
                            onInputChange={
                                (event, newInputValue) => {
                                    handleAutoCompleteChange(event, newInputValue, '', 'GetMBranch');
                                    setFormData({ ...formData, toBCode: newInputValue })
                                }}
                            maxLength='50'
                            options={autoCompleteOptions}
                            setOptions={setAutoCompleteOptions}
                        />
                        <InputBox
                            id="txtAirlineName"
                            PlaceHolderText="Airline Name"
                            autoComplete="off"
                            maxLength='30'
                            required={false}
                            label='Airline Name'
                            value={formData.airlineName}
                            onChange={(e) => setFormData({ ...formData, airlineName:e.target.value})}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtMAWB'].focus()
                                }
                            }}
                        />
                        <InputBox
                            id="txtMAWB"
                            PlaceHolderText="MAWB"
                            autoComplete="off"
                            maxLength='12'
                            required={false}
                            label='MAWB'
                            value={formData.mawb}
                            onChange={(e) => setFormData({ ...formData, mawb: convertToNumber( e.target.value) })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtPOD'].focus()
                                }
                            }}
                        />
                        <InputBox
                            id="txtPOD"
                            PlaceHolderText="POD"
                            autoComplete="off"
                            maxLength='100'
                            required={false}
                            label='POD'
                            value={formData.pod}
                            onChange={(e) => setFormData({ ...formData, pod: e.target.value })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtPOL'].focus()
                                }
                            }}
                        />
                        <InputBox
                            id="txtPOL"
                            PlaceHolderText="POL"
                            autoComplete="off"
                            maxLength='100'
                            required={false}
                            label='POL'
                            value={formData.pol}
                            onChange={(e) => setFormData({ ...formData, pol: e.target.value })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtFlightNo'].focus()
                                }
                            }}
                        />
                        <InputBox
                            id="txtFlightNo"
                            PlaceHolderText="Flight No."
                            autoComplete="off"
                            maxLength='100'
                            required={false}
                            label='Flight No.'
                            value={formData.flightNo}
                            onChange={(e) => setFormData({ ...formData, flightNo: e.target.value })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtETADate'].focus()
                                }
                            }}
                        />
                        <DateBox
                            inputrefs={inputrefs}
                            label="ETA Date"
                            placeholder="ETA Date"
                            id='txtETADate'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['btnSub'].focus()
                                };
                            }}
                            required={true}
                            selected={formData.etaDate === '' ? '' : new Date(formData.etaDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'etaDate')}
                        />
                        <InputBox
                            label='PCS'
                            divclassname='col-1'
                            PlaceHolderText='PCS'
                            inputrefs={inputrefs}
                            id='txtPCS'
                            value={formData.pcs}
                            maxLength='25'
                            disabled={true}
                        />
                        <InputBox
                            label='Weight'
                            divclassname='col-1'
                            PlaceHolderText='Weight'
                            inputrefs={inputrefs}
                            id='txtWeight'
                            value={formData.weight}
                            disabled={true}
                            maxLength='25'
                        />
                    </div>

                </div>
                <div className='card-body'>
                    <FormButton
                        id={'btnSub'}
                        inputrefs={inputrefs}
                        Export={false}
                        handleSubmit={handleSubmit}
                        handleClear={handleClear}
                        Print={invoicePrint}
                        handlePrint={handlePrint}
                    />
                </div>
            </div>

            <OperationalTable
                PageName={'DispatchEntry'}
                inputPlaceHolder='Manifest No'
                showCheckBox={true}
                Filter={false}
                loading={isLoading}
                handleCheck={handleCheck}
                handleCheckAll={handleCheckAll}
                CheckAll={CheckAll}
                tableData={tableData}
                currentPageNo={currentPageNo}
                cnNo={scanNo}
                setcnNo={setScanNo}
                handleChange1={handleChange1}
                HandleScanList={HandleScanData}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}

export default DispatchEntry;